module.exports = __webpack_public_path__ + "static/media/YM73_1.dbc3e6b5.jpg";